module.exports = __webpack_public_path__ + "static/cb-logo-6daa4fb87da2073bf573573ba65de92c.svg";